import classNames from "classnames";
import React, { Component } from "react";
import { createPortal } from "react-dom";
import storageService from "../../services/storageService";
import image from "../../assets/close.svg";
import { CartState, EDirection, EcartType } from "../enums";
import ImageSlideComponent from "../imageSlideComponent/imageSlide.component";
import TitleSlideComponent from "../titleSlideComponent/titleSlide.component";
import LoadingComponent from "../loadingComponent/loading.component";
import { ITrayComponentProps } from "../types/props";
import UserInformationFormComponent from "../userInformationFormComponent/userInformationForm.component";
import "./tray.component.scss";
import CategorySlideComponent from "../categorySlideComponent/categorySlide.component";
class TrayComponent extends Component<ITrayComponentProps> {
  create = () => {
    this.props.createPdf();
  };

  gatherUserInfo = () => {
    this.props.gatherUserInfo();
  };

  close = () => {
    this.props.closeTray();
  };

  moveSlide = (index: number, direction: EDirection) => {
    this.props.moveSlide(index, direction);
  };

  removeSlide = (index: number) => {
    this.props.removeSlide(index);
    window.dispatchEvent(new Event("presentationStorage"));
  };

  render() {
    return createPortal(
      <div>
        <div
          className={classNames({
            "pdf-tray": true,
            "pdf-tray--open": this.props.open,
            "pdf-tray--loading": this.props.cartState === CartState.LOADING,
            "pdf-tray--creating": this.props.cartState === CartState.CREATING,
          })}
        >
          <div
            className={classNames({
              "pdf-tray--header": true,
              "pdf-tray--header--pdf": this.props.pdfLink,
            })}
          >
            <span>
              <i>
                <span>{this.props.sections.length}</span>
              </i>
              Your PDF
            </span>
            <span className="pdf-tray--close">
              <button
                onClick={this.close}
                data-automation="global-challenges-pdf-tray-button-close"
              >
                {" "}
                <img src={`/dist/${image}`} />
              </button>
            </span>
          </div>
          {this.generateEmptyState()}
          {this.generatePDFLinks()}
          {this.generateLoadingIndicator()}
          {this.generateCreatingIndicator()}
          {this.props.cartType === EcartType.challenge ? this.generateImageList() : this.generateCategoryList()}
          {this.generateUserInfoForm()}
          {this.generateFooter()}
          {this.generateErrorState()}
        </div>
        <div
          onClick={this.close}
          className={classNames({
            "pdf-tray--screen-overlay": true,
            "pdf-tray--screen-overlay-active": this.props.open,
          })}
        ></div>
      </div>,
      document.getElementById("pdf-tray")
    );
  }
  generatePDFLinks = () => {
    if (!this.props.pdfLink) return null;
    if (this.props.cartType === EcartType.challenge) {
      return this.generateChallengePDFLinks();
    } else {
      return this.generateIndexedPDFLinks();
    }
  };
  generateIndexedPDFLinks = () => {
    return (
      <div className="pdf-tray--links">
        <p>
          <i className="check"></i>Your PDF has been created.
        </p>
        <button
          className="ampri-button-primary"
          onClick={this.downloadPdf}
          data-automation="global-challenges-pdf-button-download"
        >
          View PDF
        </button>
        <button className="ampri-button-tertiary" onClick={this.sendEmail}>
          Email PDF
        </button>
        <button className="ampri-button-tertiary" onClick={this.applyToBrochure}>
          Apply your selections to a custom brochure
        </button>
      </div>
    );
  };
  generateChallengePDFLinks = () => {
    return (
      <div className="pdf-tray--links">
        <p>
          <i className="check"></i>Your PDF has been created.
        </p>
        <button
          className="ampri-button-primary"
          onClick={this.downloadPdf}
          data-automation="global-challenges-pdf-button-download"
        >
          View PDF
        </button>
        <button className="ampri-button-tertiary" onClick={this.sendEmail}>
          Email PDF
        </button>
        <button className="ampri-button-secondary" onClick={this.removePDF}>
          Remove PDF
        </button>
      </div>
    );
  };
  downloadPdf = () => {
    window.open(this.props.pdfLink);
    this.props.pdfAccessed();
  };

  sendEmail = () => {
    window.open(this.generateEmailLink());
    this.props.pdfAccessed();
  };

  removePDF = () => {
    this.props.pdfAccessed();
  };

  applyToBrochure = () => {
    // Now let's generate some query params from the UserInfo and then redirect to the brochure page.
    const { clientName, advisorName, advisorPhone, advisorDesignations, advisorCustomDesignation, ratesArrangedBy, ratesIndexes } = this.props.userInfo;
    const accountIds = this.props.sections.map((section, index) => section.meta?.id);
    const params : any = {
      clientName,
      advisorName,
      advisorPhone,
      advisorDesignations: advisorDesignations.join(','),
      advisorCustomDesignation,
      ratesArrangedBy,
      ratesIndexes,
      investmentAmount: this.props.investmentAmount.toString(),
      workflow: this.props.cartSSAWorkflow.toString(),
      skipAccountSelection: this.props.skipAccountSelection.toString(),
      selectedAccounts: accountIds.join(','),
      surrenderChargeSchedule: this.props.surrenderChargeSchedule.toString(),
    };
    if (this.props.userInfo.includeCurrentRatesData) {
      params.includeRates = true;
    }
    if (this.props.userInfo.includeHistoricalPerformanceData) {
      params.includeHHP = true;
    }
    const query = new URLSearchParams(params);
    const url = `/#/structured-solutions-inputs/section1/step1?${query.toString()}`;
    // Sync selections to local storage before redirecting.
    storageService.brochurePDFConfigs = this.props.sections;
    // Now sync the selections to the local storage for the brochure app.
    this.props.pdfAccessed();

    window.location.assign(url);
  };

  generateLoadingIndicator = () => {
    if (this.props.cartState !== CartState.LOADING) return null;
    return (
      <div className="pdf-tray--load-indicator">
        <div className="pdf-tray-load-indicator--inline">
          <LoadingComponent />
          Adding to your PDF...
        </div>
        <div>
          You may close this window while this challenge is added to the PDF.
        </div>
      </div>
    );
  };

  generateCreatingIndicator = () => {
    if (this.props.cartState !== CartState.CREATING) return null;
    return (
      <div className="pdf-tray--creating-indicator">
        <div className="pdf-tray-load-indicator--inline">
          <LoadingComponent />
          Creating Your PDF...
        </div>
        <div>Please wait while your PDF is being generated.</div>
      </div>
    );
  };

  generateImageList = () => {
    if (this.props.cartState !== CartState.LISTING) return null;
    return (
      <div className="pdf-tray--list">
        <ul>{this.imageList()}</ul>
      </div>
    );
  };

  generateCategoryList = () => {
    if (this.props.cartState !== CartState.LISTING) return null;
    return (
      <div className="pdf-tray--list titles">
        <ul>{this.categoryList()}</ul>
      </div>
    );
  };

  generateUserInfoForm = () => {
    if (this.props.cartState !== CartState.GATHERING_USER_INFO) return null;
    return (
      <div className="pdf-tray--user-info">
        <UserInformationFormComponent
          userInfo={this.props.userInfo}
          clientNameRequired={this.props.cartType === EcartType.challenge}
          updateUserInfo={this.props.updateUserInfo}
          cartWorkflow={this.props.cartSSAWorkflow}
        ></UserInformationFormComponent>
      </div>
    );
  };

  generateFooter = () => {
    if (
      this.props.cartState === CartState.CREATING ||
      this.props.cartState === CartState.DISPLAYING_LINKS
    )
      return null;
    if (this.props.cartState === CartState.GATHERING_USER_INFO) {
      var clientNameRequired = this.props.cartType === EcartType.challenge;
      return (
        <div className="pdf-tray--footer">
          <div className="pdf-tray--footer-buttons">
            <button
              className="ampri-button-primary"
              disabled={clientNameRequired ? !this.props.userInfo.clientName : false}
              onClick={this.create}
              data-automation="global-challenges-pdf-button-create"
            >
              Submit
            </button>
            <button className="ampri-button-tertiary" onClick={this.close}>
              Cancel
            </button>
          </div>
        </div>
      );
    }
    return (
      <div className="pdf-tray--footer">
        <div className="pdf-tray--footer-buttons">
          <button
            className="ampri-button-primary"
            disabled={
              this.props.cartState === CartState.LOADING ||
              this.props.sections.length === 0
            }
            onClick={this.gatherUserInfo}
            data-automation="global-challenges-pdf-button-gather-info"
          >
            Create PDF
          </button>
          <button
            className="ampri-button-tertiary"
            disabled={this.props.cartState === CartState.LOADING}
            onClick={this.close}
          >
            {this.returnButtonText()}
          </button>
        </div>
      </div>
    );
  };

  generateEmptyState = () => {
    if (this.props.cartState !== CartState.EMPTY) return null;
    if(this.props.cartType === EcartType.challenge){
      return (
        <div className="pdf-tray--empty">
          <p>Your PDF is Empty</p>
          <p>Add Challenges to get started.</p>
        </div>
      );
    }
    return (
      <div className="pdf-tray--empty">
        <p>Your PDF is Empty</p>
        <p>Add Selections to get started.</p>
      </div>
    );
  };

  generateErrorState = () => {
    if (this.props.cartState !== CartState.ERROR) return null;
    return (
      <div className="pdf-tray--error">
        <h3>Error</h3>
        <p>
          An error has occured, please try again or contact the site
          administrator.
        </p>
      </div>
    );
  };

  imageList = (): JSX.Element[] => {
    return this.props.sections.map((section, index) => {
      return (
        <div className="image-view-link" key={index}>
          <ImageSlideComponent
            key={index}
            challenge={section.name}
            image={section.screenshot}
            index={index}
            last={index === this.props.sections.length - 1}
            moveSlide={this.moveSlide}
            removeSlide={this.removeSlide}
          />
          {this.imageLink(section.image)}
        </div>
      );
    });
  };

  categoryList = (): JSX.Element[] => {
    // Sort the categories in a specific order if we have not customized the order.
    const categoryOrder = [
      'standard',
      'dual',
      'annual_lock',
      'contingent_return',
      'income_choice',
      'annual_fee',
      'dual_directional_w_annual_fee'
    ];

    if (this.props.indexedCategoriesDefaultSort) {
      this.props.indexedCategories.sort((a, b) => {
        const indexA = categoryOrder.indexOf(a);
        const indexB = categoryOrder.indexOf(b);
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });
    }

    return this.props.indexedCategories.map((category, index) => {
      let sections = this.props.sections.filter((section) => section.meta.category === category);
      if (sections.length === 0) return null;
      return (
        <div className="image-view-link" key={index}>
          <CategorySlideComponent
            key={index}
            sections={sections.sort()}
            category={category}
            index={index}
            last={index === this.props.indexedCategories.length - 1}
            moveSlide={this.moveSlide}
            removeSlide={this.removeSlide}
          />
        </div>
      );
    });
  };

  imageLink(image: string | undefined) {
    if (image && storageService.debugActive)
      return (
        <a href={image} target="_blank">
          View Image Sent To Backend
        </a>
      );
    else return null;
  }

  generateEmailLink() {
    const url = `${window.location.protocol}//${window.location.host}`;
    return `mailto:?subject=Custom%20Retirement%20Challenge&body=${url}${this.props.pdfLink}`;
  }

  returnButtonText() {
    if(this.props.cartType === EcartType.challenge){
      return 'Add more challenges';
    }
    return 'Add More Selections'
  }
}

export default TrayComponent;
